import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'

import App, { AppProps } from './App'

import StandaloneError from './components/StandaloneError'

const lifecycles = singleSpaReact<AppProps>({
    React,
    ReactDOM,
    rootComponent: App,
    errorBoundary(err) {
        if (process.env.standalone) {
            return <StandaloneError details={err.stack || ''} message={err.message} title={err.name} />
        }
        return <p>{err.message}</p>
    },
})

export async function bootstrap(props: any) {
    return lifecycles.bootstrap(props)
}

export const { mount } = lifecycles

export const unmount = async (props: any) => {
    lifecycles.unmount(props)
}
